import { useEffect, useState } from 'react';

import { Box } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import copy from 'copy-to-clipboard';
import { useSnackbar } from 'notistack';
import { useModal } from 'react-modal-hook';

import { WppButtonType } from 'store/reducers/templates';

import CopyButton from './CopyButton';
import MessageBase, { MessageBaseProps } from './MessageBase';
import MessageErrorFallback from './MessageErrorFallback';
import TemplateListOptions from './TemplateListOptions';
import TemplateMessageContent from './TemplateMessageContent';

type TemplateMessageProps = MessageBaseProps;

const THREE_SECONDS_IN_MILLISECONDS = 3000;

export default function TemplateMessage({ ...props }: TemplateMessageProps) {
  const { enqueueSnackbar } = useSnackbar();

  const [copied, setCopied] = useState(false);
  const [showCopyButton, setShowCopyButton] = useState(false);
  const [buttons, setButtons] = useState<WppButtonType[]>([]);

  const [showTemplateListOptions, hideTemplateListOptions] = useModal(
    ({ in: open }) => {
      if (!buttons) return null;

      return (
        <TemplateListOptions
          buttons={buttons}
          open={open}
          onClose={hideTemplateListOptions}
        />
      );
    },
    [buttons],
  );

  useEffect(() => {
    if (copied) {
      const timeoutId = setTimeout(() => {
        setCopied(false);
      }, THREE_SECONDS_IN_MILLISECONDS);

      return () => clearTimeout(timeoutId);
    }
    return () => null;
  }, [copied]);

  try {
    const handleClickShowMoreButtons = (buttons: WppButtonType[]) => {
      setButtons(buttons);
      showTemplateListOptions();
    };

    const template = props.mensagem.whatsappTemplateData;
    const body = template?.components?.find(c => c.type === 'BODY');

    const handleMouseEnter = () => setShowCopyButton(true);
    const handleMouseLeave = () => setShowCopyButton(false);

    const handleCopy = () => {
      setCopied(true);
      copy(body && body.text ? body.text : '');
      enqueueSnackbar('Texto copiado para a àrea de transferência.');
    };

    return (
      <MessageBase {...props}>
        <Box
          position="relative"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Slide
            direction="left"
            in={showCopyButton}
            mountOnEnter
            unmountOnExit
          >
            <Box position="absolute" top={0} bottom={0} right={0}>
              <CopyButton copied={copied} onCopy={handleCopy} />
            </Box>
          </Slide>

          <TemplateMessageContent
            fromMe={props.fromMe}
            template={template}
            onShowMoreButtons={() =>
              handleClickShowMoreButtons(
                (template?.components?.find(c => c.type === 'BUTTONS')
                  ?.buttons as WppButtonType[]) || [],
              )
            }
          />
        </Box>
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
